import React, { useState, useEffect, Fragment } from 'react';
import { Box, IconButton, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import {
    //   Search as SearchIcon,
    ChevronLeft as KeyboardArrowLeft,
    ChevronRight as KeyboardArrowRight,
    ChevronsLeft as FirstPageIcon,
    ChevronsRight as LastPageIcon,
} from 'react-feather';

const useStyles = makeStyles((Theme) => ({
    selectedPage: {
        color: Theme.palette.primary.main,
    },
}));

const CustomPagination = (props) => {
    const { page, limit, handlePageChange, count, showSelectPages = 4 } = props;
    const [totalPages, setTotalPages] = useState(0);
    const classes = useStyles();

    useEffect(() => {
        var newTotalPages = Math.ceil(count / limit);
        if (newTotalPages) {
            setTotalPages(newTotalPages);
        }
    }, [limit, count]);

    const handleFirstPageButtonClick = (event) => handlePageChange(event, 0);

    const handleBackButtonClick = (event) => handlePageChange(event, page - 1);

    const handleNextButtonClick = (event) => handlePageChange(event, page + 1);

    const handleLastPageButtonClick = (event) =>
        handlePageChange(event, Math.max(0, Math.ceil(count / limit) - 1));

    const handleSelectPage = (selectedPage) =>
        handlePageChange('', selectedPage);

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPageIcon />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            {count &&
                limit &&
                totalPages > 0 &&
                [...Array(totalPages).keys()].map((currentPage, key) => {
                    var lastPage = currentPage >= Math.ceil(count / limit) - 1;
                    if (
                        lastPage ||
                        (totalPages - showSelectPages < page &&
                            currentPage > page - showSelectPages) ||
                        (currentPage >= page &&
                            currentPage < page + showSelectPages)
                    ) {
                        return (
                            <Fragment key={key}>
                                {lastPage &&
                                    totalPages - showSelectPages >= 2 &&
                                    !(
                                        totalPages - showSelectPages < page &&
                                        currentPage > page - showSelectPages
                                    ) && (
                                        <IconButton disabled={true}>
                                            <Typography>...</Typography>
                                        </IconButton>
                                    )}
                                <IconButton
                                    disabled={page === currentPage}
                                    onClick={() =>
                                        handleSelectPage(currentPage)
                                    }
                                >
                                    <Typography
                                        className={clsx({
                                            [classes.selectedPage]:
                                                currentPage === page,
                                        })}
                                    >
                                        {currentPage + 1}
                                    </Typography>
                                </IconButton>
                            </Fragment>
                        );
                    }
                    return false;
                })}

            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / limit) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / limit) - 1}
                aria-label="last page"
            >
                <LastPageIcon />
            </IconButton>
        </Box>
    );
};

export default CustomPagination;
